import {
  Button,
  ICONS,
  Loader,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetAllEmployeesForList } from 'src/hooks/employees/get-all-employees-for-list.hook';
import { StyledRateInput } from 'src/pages/vacancies/sub-pages/vacancy-details/components/styled-rate-input';

import {
  FeedbackInfoWrapper,
  ElementWrapper,
  InfoElement,
} from './applicant-feedbacks-info.styles';

const ApplicantFeedbacksInfo = ({
  feedbacks,
  onClickEdit,
}: {
  feedbacks: any;
  onClickEdit: () => void;
}) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const companyId = useGetCurrentCompanyId;
  const { employees, loading } = useGetAllEmployeesForList({
    filter: { accountActive: true, companyId },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <FeedbackInfoWrapper>
      <div>
        <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employee:employeeInterview.labels.feedback')}
        </Typography>
        <Button
          type="primary"
          ghost
          icon={ICONS.editAlt}
          onClick={onClickEdit}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
        >
          {t('common:buttons.edit')}
        </Button>
      </div>
      <ElementWrapper>
        {feedbacks.map((item: any) => {
          const employee = employees.find((employee: any) => employee._id === item.feedbackFrom);

          return (
            <div key={item.feedbackFrom}>
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.feedbackFrom')}:</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {employee?.profile?.displayName}
                </Typography>
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">{t('vacancies:labels.rating')}:</Typography>
                <StyledRateInput value={item.rating} disabled />
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">
                  {t('employee:employeeInterview.labels.feedback')}:
                </Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {item.feedback || '-'}
                </Typography>
              </InfoElement>
            </div>
          );
        })}
      </ElementWrapper>
    </FeedbackInfoWrapper>
  );
};

export default ApplicantFeedbacksInfo;
